import { render, staticRenderFns } from "./SearchPokemon.vue?vue&type=template&id=28c5e4c8&"
import script from "./SearchPokemon.vue?vue&type=script&lang=ts&"
export * from "./SearchPokemon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports